/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';

class SessionModel {
  constructor(data) {
    this.data = _.assign({}, {
      user: {},
    }, data);
  }

  userId() {
    return this.data.user.id;
  }

  tokenType() {
    return this.data.type;
  }

  getMillisecsUntilRefresh() {
    const refreshInMillisecs = this.data.exp * 1000;
    return refreshInMillisecs - new Date().getTime();
  }

  getMillisecsDuration() {
    return Math.max(this.data.exp - this.data.iat, 1) * 1000;
  }

  requiresMfa() {
    return this.data.type === 'mfa';
  }

  userData() {
    return this.data.user;
  }

  isTrusted() {
    return this.data.duration === 'long';
  }
}

export default SessionModel;
